/**
 * 打平权限对象，并且将权限字符串全部转换为小写
 * @param {*} permissions
 * @returns {string[]}
 */
export const flatPermissions = (permissions) => {
	const flat = [];

	const flatFn = (permissions, parent) => {
		for (const key in permissions) {
			const value = permissions[key];
			const lowerCaseKey = key.toLowerCase();

			if (typeof value === "object") {
				flatFn(value, parent ? `${parent}/${lowerCaseKey}` : lowerCaseKey);
			} else {
				flat.push(parent ? `${parent}/${lowerCaseKey}` : lowerCaseKey);
			}
		}
	};

	flatFn(permissions);

	return flat;
};
